import { getProducts } from "../services/Rest.jsx";
import useFetch from "./useFetch.jsx";

const useProducts = () => {
  return useFetch(getProducts, true);
};

export default useProducts;
